import { render } from "./MentorCardAddresses.vue?vue&type=template&id=7f046038"
import script from "./MentorCardAddresses.vue?vue&type=script&lang=js"
export * from "./MentorCardAddresses.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src439103385/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__